import { render, staticRenderFns } from "./diagram-view-canvas.component.vue?vue&type=template&id=6c5cc236"
import script from "./diagram-view-canvas.component.ts?vue&type=script&lang=ts&external"
export * from "./diagram-view-canvas.component.ts?vue&type=script&lang=ts&external"
import style0 from "./diagram-view-canvas.component.vue?vue&type=style&index=0&id=6c5cc236&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c5cc236')) {
      api.createRecord('6c5cc236', component.options)
    } else {
      api.reload('6c5cc236', component.options)
    }
    module.hot.accept("./diagram-view-canvas.component.vue?vue&type=template&id=6c5cc236", function () {
      api.rerender('6c5cc236', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/diagram-view/diagram-view-canvas/diagram-view-canvas.component.vue"
export default component.exports